import { ALTERAR_REGISTROS_POR_PAGINA_PRECO } from '../types'

export default function alterarRegistrosPorPaginaPreco (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_PRECO,
    payload: valor
  }
}
